import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReddyLayout from '../components/home/ReddyLayout';
import { useReddyAuth, DEMO_USER } from '../components/home/ReddyAuth';
import Overview from '../components/profile/Overview';
import StakeSettings from '../components/profile/StakeSettings';
import ChangePassword from '../components/profile/ChangePassword';
import { IMG } from '../data/homeData';

/* blue person-in-circle avatar placeholder (real profile_image.png is live-server-only) */
const AVATAR_PH =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='50' fill='%235b9bd5'/><circle cx='50' cy='40' r='16' fill='%23dbe9f7'/><path d='M22 84 a28 24 0 0 1 56 0 z' fill='%23dbe9f7'/></svg>";

const TABS = [
  { label: 'Overview', path: '/profile' },
  { label: 'Stack Settings', path: '/profile/stake-settings' },
  { label: 'Change Password', path: '/profile/change-password' },
];

export default function ReddyProfilePage() {
  const { user, login } = useReddyAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // post-login page — ensure a demo session so the header + body render logged-in
  useEffect(() => { if (!user) login(); }, [user, login]);
  const u = user || DEMO_USER;

  const found = TABS.findIndex((t) => t.path === location.pathname);
  const activeIdx = found < 0 ? 0 : found;

  return (
    <ReddyLayout>
      <section className="section profile">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="userscreen-title">profile</h2>
          </div>

          {/* left — avatar card */}
          <div className="col-xl-4">
            <div className="card">
              <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                <img
                  src={`${IMG}/profile_image.png`}
                  alt="Profile"
                  className="rounded-circle"
                  onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = AVATAR_PH; }}
                />
                <h2>{u.id}</h2>
              </div>
            </div>
          </div>

          {/* right — tabs card */}
          <div className="col-xl-8">
            <div className="card">
              <div className="card-body">
                <div className="tab-container">
                  <ul role="tablist" className="nav nav-tab nav-tabs-bordered" aria-label="Tabs">
                    {TABS.map((t, i) => {
                      const on = i === activeIdx;
                      return (
                        <li className={on ? 'active nav-item' : 'nav-item'} key={t.path}>
                          <a
                            href="javascript:void(0);"
                            role="tab"
                            aria-selected={on}
                            className={on ? 'nav-link active' : 'nav-link'}
                            onClick={(e) => { e.preventDefault(); navigate(t.path); }}
                          >
                            <span />
                            <button type="button" className="nav-link" tabIndex={0}>{t.label}</button>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="tab-content">
                    <div role="tabpanel" className="tab-pane active">
                      {activeIdx === 0 && <Overview user={u} />}
                      {activeIdx === 1 && <StakeSettings />}
                      {activeIdx === 2 && <ChangePassword />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
